import * as Actions from "../../ApiCallStatus/Actions/action";
import { Constant } from "../../../Constants/constant";
import { GetAllCookAction } from "../Actions/action";
import { FETCH } from "../../../Services/fetch";
export function getAllCook(offset, limit, type) {
    return async (dispatch) => {
        dispatch(Actions.ApiRequestedAction({ apiCallFor: "getAllCook" }));
        let myJson = await FETCH("GET", Constant.apiURl + `/users/${offset}/${limit}?type=${type}`);
        if (myJson && myJson.code === 201) {
            dispatch(GetAllCookAction(myJson.data))
            dispatch(
                Actions.ApiFulfilledAction({
                    apiCallFor: "getAllCook",
                    message: myJson.message,
                }))
        }
        else {
            dispatch(Actions.ApiRejectedAction({ statusCode: myJson.statusCode, apiCallFor: "getAllCook", message: myJson.message }))
        }
    };
}